import React, { useEffect, useState } from 'react';
import './_itemCart.scss';
import { Formater } from '../../globals/otherFunctions';
import imgPlaceHolder from '../../Assets/png/placeHolderProduct.png';
import speak from '../../InternalFunctions';

export const ItemCart = ({id, nombre, cod, unitPrice, unitPaq, category, cantidad, onDelete, updtC, ImgName}) => {
    
    const [cant, setCant] = useState(parseInt(cantidad))
    const [totalPrice, setTotalPrice] = useState(unitPrice*cant)
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [fontResize, setFontResize] = useState('');
    const [imgSrc, setImgSrc] = useState(`https://sivarwebresources.s3.amazonaws.com/AVIF/${ImgName}.avif`);

    const handleDelete = () =>{        
        onDelete(id)
    }
    
    const resize_ob = new ResizeObserver(()=>{
        setScreenWidth(window.innerWidth);
    });

    useEffect(() => {
        const theId = 'a' + id
        resize_ob.observe(document.querySelector('#'+theId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {        
        if(screenWidth<431){
            //console.log(screenWidth);
            setFontResize('1.7rem')
        }else{
            setFontResize('')
        }
        // eslint-disable-next-line
    }, [screenWidth]);

    const handleError = () =>{
        //console.log(`img ${cod} not found`);
        setImgSrc(imgPlaceHolder)
    }


    //TODO: to update the image if this image is new
    useEffect(() => {
        const imageUrl = `https://sivarwebresources.s3.amazonaws.com/AVIF/${ImgName}.avif`;
    
        // Verificar el ETag del servidor
        fetch(imageUrl, { method: "HEAD" })
          .then((response) => {
            const eTag = response.headers.get("ETag"); // Obtener el ETag
            if (eTag) {
              setImgSrc(`${imageUrl}?v=${eTag}`); // Agregar el ETag como versión
            } else {
              setImgSrc(imageUrl); // Si no hay ETag, usar la URL normal
            }
          })
          .catch((error) => {
            console.error("Error verificando el ETag:", error);
            setImgSrc(imageUrl); // En caso de error, mostrar la imagen igual
          });
        setCant(parseInt(cantidad));
        setTotalPrice(unitPrice * parseInt(cantidad));
      }, [cod]);
    //TODO: end of the todo

    /*useEffect(() => {        
        setImgSrc(`https://sivarwebresources.s3.amazonaws.com/AVIF/${cod}.avif`)
        setCant(parseInt(cantidad))
        setTotalPrice(unitPrice*(parseInt(cantidad)))
        // eslint-disable-next-line
    }, [cod]);*/

    return (
        <div className='itemCartStyle' id={`a${id}`} >
            <div className='delContainer' role='button' 
                data-bs-toggle="modal"
                data-bs-target={`#verifyDel${id}`}
            >
                <i className="bi bi-trash3"></i>
            </div>
            <div className='itemCartImgContainer'>
                <div className={`imgProducto itemCartImg C${category}`}>
                    <picture>
                        <source
                            type="image/avif"
                            srcSet={imgSrc}
                        />
                        <img
                            src={imgSrc}
                            onError={handleError}
                            alt="categoria"
                            decoding="async"
                        />
                    </picture>                    
                </div>
            </div>
            <div className='detailsItem'>
                <div className='subTit' style={{lineHeight: '1.1'}}><strong>{nombre}</strong>
                    <div className='smolText' style={{color: '#747474'}}>{cod}</div>
                </div>
                <div style={{marginTop: '10px'}}>
                    V.U: $ {Formater(unitPrice)}
                </div>
                <div className="quantityBox">
                    <button className="btnQuantity" onClick={() => {
                        if((cant-unitPaq)>0){
                            updtC(id, parseInt(cant)-unitPaq)
                            setCant(cant-unitPaq)
                            setTotalPrice(unitPrice*(cant-unitPaq))
                        }
                    }}>
                        -
                    </button>
                    <input
                        className='quantity' type="number"
                        min={1}
                        value={cant}
                        style={{width: `${(String(cant).length*14.4)+24}px`}} //here i change the with in function of the length of the content plus 24 of padding                        
                        onChange={(e)=>{setCant(parseInt(e.target.value));}}
                        onBlur={(e)=>{
                            let theCant = parseInt(e.target.value)                            
                            if(e.target.value%unitPaq !== 0){
                                theCant = parseInt(Math.ceil(e.target.value / unitPaq) * unitPaq)
                                setCant(theCant);
                            }
                            setTotalPrice(unitPrice*theCant)
                            updtC(id, theCant)
                        }}
                    />
                    <button className="btnQuantity" onClick={() => {
                        updtC(id, parseInt(cant)+unitPaq)
                        setCant(parseInt(cant)+unitPaq)
                        setTotalPrice(unitPrice*(parseInt(cant)+unitPaq))                        
                    }}>
                        +
                    </button>
                </div>
                <div className="totalPrice inItemCart mainBlue">
                    <div className='subTit fw-bold'>Total:</div>
                    <h1>
                        <span className='text-black Tit' style={{fontSize: `${fontResize}`}}>
                            ${Formater(totalPrice)}
                        </span>
                    </h1>
                </div>
            </div>
            <div className="modal fade" id={`verifyDel${id}`} tabIndex="-1" aria-labelledby="VerifyDel" aria-hidden="true">
                <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">Desea eliminar este producto?</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="button" className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleDelete}
                            >Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
